export default {
    light: {
        primary: "#236EB6",
        secondary: "#FDC62C",
        secondaryDark: "#876300",
        error: "#E1001A",
        info: "#32B3EE",
        success: "#00961A",
        warning: "#EFA500",
        headerColor: "#FFFFFF",
        menuColor: "#333333",
        headerDialogColor: "#DCDBDC",
        TxtOnGoing: "#3699FF",
        subMenuActive: "#636363",
        // Action butons
        edit: "#ffb469",
        see: "#31CAE3",
        delete: "#ff6571",
        pdf: "#b11010",
        qrcode: "#3158E3",
        play: "#1BC5BD",
        stop: "#F64E60",
        done: "#DCDBDC",
        print: "#ED7632",
        reset: "#A20BD7",
        // Chips
        bgChipsValide: "#C9F7F5",
        TxtChipsValide: "#1BC5BD",
        bgChipsCancel: "#FFE2E5",
        TxtChipsCancel: "#F64E60",
        bgChipsCareful: "#FCE5D3",
        TxtChipsCareful: "#F6754E",
        bgChipsOnGoing: "#E1F0FF",
        TxtChipsOnGoing: "#3699FF",
        tabColor: "#D8DDE2",
        tabColorActive: "#DFEFFF",
        black: "#000"
    },
    dark: {
        primary: "#236EB6",
        secondary: "#FDC62C",
        secondaryDark: "#876300",
        error: "#E1001A",
        info: "#32B3EE",
        success: "#00961A",
        warning: "#EFA500",
        headerColor: "#FFFFFF",
        menuColor: "#333333",
        headerDialogColor: "#DCDBDC",
        TxtOnGoing: "#3699FF",
        subMenuActive: "#636363",
        // Action butons
        edit: "#ffb469",
        see: "#31CAE3",
        delete: "#ff6571",
        pdf: "#b11010",
        qrcode: "#3158E3",
        play: "#1BC5BD",
        stop: "#F64E60",
        print: "#ED7632",
        reset: "#A20BD7",
        // Chips
        bgChipsValide: "#C9F7F5",
        TxtChipsValide: "#1BC5BD",
        bgChipsCancel: "#FFE2E5",
        TxtChipsCancel: "#F64E60",
        bgChipsCareful: "#FCE5D3",
        TxtChipsCareful: "#F6754E",
        bgChipsOnGoing: "#E1F0FF",
        TxtChipsOnGoing: "#3699FF",
        tabColor: "#D8DDE2",
        tabColorActive: "#DFEFFF",
    },
};
